const DEFAULT_LINE_HEIGHT = 16;
const DEFAULT_FONT_SIZE = 13;

export const INPUT_LINE_HEIGHT_RATIO = DEFAULT_LINE_HEIGHT / DEFAULT_FONT_SIZE;

export const DEFUALT_INPUT_WIDGET_WIDTH = 320;
